import { render, staticRenderFns } from "./SliderBar.vue?vue&type=template&id=f2a8789a&scoped=true&"
import script from "./SliderBar.vue?vue&type=script&lang=js&"
export * from "./SliderBar.vue?vue&type=script&lang=js&"
import style0 from "./SliderBar.vue?vue&type=style&index=0&id=f2a8789a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a8789a",
  null
  
)

export default component.exports